import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  NO_VALUE_DISPLAY,
  resolveLiveMapDelayStatusForDisplay,
  RideDelayStatusEnum,
} from "@ryde/shared";

import { buildLiveMapDelayStatusBadgePalette } from "../../../utils";
import { LiveMapStatusBadgeStyled } from "./live-map-status-badge.styled";

export interface ILiveMapDelayStatusBadge {
  status?: RideDelayStatusEnum | null;
}

export const LiveMapDelayStatusBadge: FC<ILiveMapDelayStatusBadge> = ({
  status,
}) => {
  const { t } = useTranslation();
  const resolvedStatus = resolveLiveMapDelayStatusForDisplay(status);

  const palette = useMemo(
    () => buildLiveMapDelayStatusBadgePalette(resolvedStatus),
    [resolvedStatus],
  );

  if (!palette) {
    return <span>{NO_VALUE_DISPLAY}</span>;
  }

  return (
    <LiveMapStatusBadgeStyled
      $backgroundColor={palette.backgroundColor}
      $borderColor={palette.borderColor}
      $color={palette.color}
      $dataE2e="live-map-delay-status-badge"
    >
      {t(`rideMap.delayStatus.${resolvedStatus}`)}
    </LiveMapStatusBadgeStyled>
  );
};
